import { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { keys } from "@/lib/i18n/portal";
import { ApiJsonClientError } from "@/lib/query/core/api-json-client";
import { AppShell } from "@/shared/layout/AppShell";
import { Surface } from "@/shared/layout/Surface";
import { getLocaleDirection } from "@/lib/i18n/portal";
import { useTranslations } from "@/lib/i18n/intl";
import { useLocale } from "./locale";
import { useSessionQuery } from "@/shared/services/useSessionQuery";

export function ProtectedLayout() {
  const locale = useLocale();
  const location = useLocation();
  const navigate = useNavigate();
  const t = useTranslations();
  const { data, isLoading, error } = useSessionQuery();

  useEffect(() => {
    if (
      error instanceof ApiJsonClientError &&
      (error.status === 401 || error.status === 403)
    ) {
      navigate(`/${locale}/admin/login`, { replace: true });
    }
  }, [error, locale, navigate]);

  if (
    error instanceof ApiJsonClientError &&
    (error.status === 401 || error.status === 403)
  ) {
    return <Navigate to={`/${locale}/admin/login`} replace />;
  }

  if (isLoading) {
    return (
      <Surface
        locale={locale}
        direction={getLocaleDirection(locale)}
        title={t(keys.common.loading)}
      >
        <div className="text-sm text-[color:var(--portal-muted)]">
          {t(keys.common.loading)}
        </div>
      </Surface>
    );
  }

  return (
    <AppShell
      locale={locale}
      isSuperAdmin={data?.admin?.roles?.includes("SUPER_ADMIN")}
      adminId={data?.admin?.id}
      adminName={data?.admin?.name}
      adminRoles={data?.admin?.roles}
      firebaseToken={data?.firebaseToken}
      key={location.pathname}
    >
      <Outlet />
    </AppShell>
  );
}
